<div class="header-container">
  <div class="header-title">
    {{ translationKeys.avano.notifications.msg.header | translate }}
  </div>
  <div class="header-actions">
    <avano-toggle-switch
      [labelLeft]="translationKeys.avano.notifications.btn.showAll | translate"
      [labelRight]="translationKeys.avano.notifications.btn.unread | translate"
      [ngModel]="unread"
      (ngModelChange)="toggleUnread($event)"
    ></avano-toggle-switch>
    <button class="avano-icon-btn" *ngIf="false">
      <i class="icon-content-settings"></i>
    </button>
  </div>
</div>
